import { useActiveTripLeg, useVfCloseModal } from "../store/model-misc";
import { useColDefs } from "./opps-table-coldefs";
import AgTable from "./AgTable";
import React from "react";
import _ from "lodash";
import {
  useIsFlopptions,
  useIsReportActionFormOpen,
} from "./reporting-actions/modal-or-drawer";
import { Dialog, Spinner } from "@blueprintjs/core";
import { useStoreState } from "../hooks/ep";

export function FlopptionsModalWrapper(props) {
  return useIsFlopptionsTableReady() && <FlopptionsDialog {...props} />;
}
function useActiveTripLegFlopptionsRows() {
  const activeTripLeg = useActiveTripLeg();
  const { TripId, leg_i } = activeTripLeg || { TripId: null, leg_i: null };
  const ret = useStoreState(
    (s) => s.flopptions.rowsByTripLegId[`${TripId}|${leg_i}`],
    [TripId, leg_i]
  );
  console.log({ activeTripLeg, ret });
  return activeTripLeg ? ret : [];
}

export function useIsFlopptionsTableReady() {
  const isFlopptions = useIsFlopptions();
  const flopptionsRows = useActiveTripLegFlopptionsRows();
  const isReady = isFlopptions && !!(flopptionsRows && _.size(flopptionsRows));
  return isReady;
}

export function useFlopptionsTitle() {
  const { TripId, leg_i } = useActiveTripLeg();
  const legName = leg_i && ["Inb", "Ret"][leg_i - 1];
  return (
    <span>
      Flight Options for Trip Leg Opportunity:&nbsp;
      <span
        css={`
          font-weight: bolder;
        `}
      >
        {TripId} {legName ? `(${legName})` : ""}
      </span>
    </span>
  );
}

export function FlopptionsDialog() {
  const closeModal = useVfCloseModal();
  const drawerOpen = useIsReportActionFormOpen();

  return (
    <div
      css={`
        .bp3-dialog-container {
          width: ${drawerOpen ? "calc(100vw - 500px)" : "100vw"};
        }
      `}
    >
      <Dialog
        isOpen={true}
        onClose={closeModal}
        canEscapeKeyClose={false}
        title={useFlopptionsTitle()}
        usePortal={false}
        css={`
          width: 95%;
        `}
      >
        <div
          css={`
            height: 58vh;
            padding: 24px;
            width: 100%;
          `}
        >
          <div
            css={`
              width: 100%;
            `}
          >
            <FlopptionsTable height={"50vh"} />
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export function FlopptionsTable({ height }) {
  const flopptionsRows = useActiveTripLegFlopptionsRows();
  const colDefs = useColDefs("flopptions");
  return _.size(flopptionsRows) === 0 ? (
    <Spinner />
  ) : (
    <AgTable
      tableName="flopptions"
      rowData={flopptionsRows}
      columnDefs={colDefs}
      height={height}
    />
  );
}
